import { render, staticRenderFns } from "./ResourceEffort.vue?vue&type=template&id=9577108e&scoped=true&"
import script from "./ResourceEffort.vue?vue&type=script&lang=js&"
export * from "./ResourceEffort.vue?vue&type=script&lang=js&"
import style0 from "./ResourceEffort.vue?vue&type=style&index=0&id=9577108e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9577108e",
  null
  
)

export default component.exports